import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { stripeService } from '../../services/stripe';
import { CreditCard, Loader2 } from 'lucide-react';

interface SubscriptionButtonProps {
  className?: string;
  variant?: 'primary' | 'secondary';
}

export const SubscriptionButton: React.FC<SubscriptionButtonProps> = ({ 
  className = '',
  variant = 'primary'
}) => {
  const { firebaseUser } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubscribe = async () => {
    if (!firebaseUser) {
      alert('Please sign in to subscribe.');
      return;
    }

    try {
      setIsLoading(true);
      const token = await firebaseUser.getIdToken();
      await stripeService.redirectToCheckout(token);
    } catch (error) {
      console.error('Failed to start checkout:', error);
      alert('Failed to start checkout. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const baseClasses = variant === 'primary' 
    ? 'bg-blue-600 hover:bg-blue-700 text-white'
    : 'bg-gray-100 hover:bg-gray-200 text-gray-700';

  return (
    <button
      onClick={handleSubscribe}
      disabled={isLoading}
      className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${baseClasses} ${className}`}
    >
      {isLoading ? (
        <Loader2 className="w-5 h-5 animate-spin" />
      ) : (
        <CreditCard className="w-5 h-5" />
      )}
      <span className="text-sm">
        {isLoading ? 'Starting checkout...' : 'Subscribe for $2/month'}
      </span>
    </button>
  );
};
